import { Button, type ButtonProps, Tooltip } from "@heroui/react";
import { Icon } from "@iconify/react";

import { useDarkModeSSR, useIsMounted, useLanguage } from "@onesolution/hooks";

type ThemeSwitcherProps = {
	size?: ButtonProps["size"];
	disableTooltip?: boolean;
};

export default function ThemeSwitcher({
	size = "lg",
	disableTooltip = true,
}: ThemeSwitcherProps) {
	const { t } = useLanguage();
	const { isDarkMode, toggle } = useDarkModeSSR();
	const isMounted = useIsMounted();

	if (!isMounted) return null;

	return (
		<Tooltip
			content={t("basic.switch-theme")}
			isDisabled={disableTooltip}
			placement="right"
		>
			<Button
				isIconOnly
				color="default"
				variant={isDarkMode ? "light" : "flat"}
				onPress={toggle}
				size={size}
			>
				<Icon
					className="size-5 transition-all duration-500"
					icon={isDarkMode ? "solar:moon-bold" : "solar:sun-bold"}
				/>
			</Button>
		</Tooltip>
	);
}
